import { render, staticRenderFns } from "./WaitingValuesAdd.vue?vue&type=template&id=4982201f&scoped=true&"
import script from "./WaitingValuesAdd.vue?vue&type=script&lang=js&"
export * from "./WaitingValuesAdd.vue?vue&type=script&lang=js&"
import style0 from "./WaitingValuesAdd.vue?vue&type=style&index=0&id=4982201f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4982201f",
  null
  
)

export default component.exports